<template>
  <div class="headImg">
    <div class="banner">
      <img src="@/assets/leadAroud/dp-ld-sy1.png" alt />
    </div>
    <div class="banners">
      <img src="@/assets/leadAroud/dp-ld-sy2.png" alt />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  name:'headImg',
};
</script>
<style lang='scss' scoped>
.headImg {
  .banners {
    img {
      width: 100%;
    }
    text-align: center;
    padding: 0.3rem 0.2rem;
    background: #fff;
    font-size: 0;
  }
  .banner {
    img {
      width: 100%;
    }
    font-size: 0;
  }
}
</style>